import React from 'react';
import PropTypes from 'prop-types';
import PlayArrow from '@material-ui/icons/PlayArrow';

import CDModule from './CDModule';

const styles = {
  card: {
    backgroundColor: '#FFFFFF',
    // boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12)',
    border: '1px solid #e8e8e8',
    // border: `2px solid ${bizminderColors[0]}`,
    borderRadius: 2,
    width: '100%',
    padding: 15,
    margin: '20px 0',
  },
  titleImage: {
    width: 30,
  },
  cardHeading: {
    paddingLeft: 15,
    fontSize: 20,
    paddingTop: 3,
    margin: 0,
  },
  cardContent: {
    margin: '10px 0',
  },
};

const CDProgressDetailsCard = (props) => {
  const { color, title, image, modules, pbBgColor, progress } = props;
  const iconStyle = {
    fontSize: '36px',
    marginTop: 5,
    color,
  };
  return (
    <div style={styles.card}>
      <div className="row no-gutters">
        <div className="col-auto"><img style={styles.titleImage} src={image} alt={title} /></div>
        <div className="col"><h5 style={styles.cardHeading}>{ title }</h5></div>
      </div>

      <div className="row no-gutters" style={styles.cardContent}>
        {
          modules.map((moduleName, index) => {
            if (index === 0) {
              return (
                <div key={moduleName} className="col-md-3 col-xl-2">
                  <CDModule title={moduleName} progressPercent={progress[index] ? progress[index] : 0} progressBarColor={color} progressBarBgColor={pbBgColor} />
                </div>
              );
            }
            return ([
              <div key={`${moduleName}__arrow`} className="col-auto">
                <PlayArrow style={iconStyle} />
              </div>,
              <div key={moduleName} className="col-md-3 col-xl-2">
                <CDModule title={moduleName} progressPercent={progress[index] ? progress[index] : 0} progressBarColor={color} progressBarBgColor={pbBgColor} />
              </div>,
            ]);
          })
        }
      </div>
    </div>
  );
};

CDProgressDetailsCard.propTypes = {
  color: PropTypes.string.isRequired,
  pbBgColor: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  modules: PropTypes.arrayOf(PropTypes.string).isRequired,
  progress: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default CDProgressDetailsCard;



// WEBPACK FOOTER //
// ./src/components/CDProgressDetailsCard.jsx